/**
 * 认证相关API（兼容旧引用）
 */
import { AuthAPI } from '@/api'

// Wrap AuthAPI methods instead of re-exporting the properties directly to
// prevent circular import evaluation from throwing a temporal dead zone error.
export const sendVerificationCode = (phone) => AuthAPI.sendVerificationCode(phone)
export const phoneLogin = (phone, code) => AuthAPI.phoneLogin(phone, code)
export const cmiLogin = (data) => AuthAPI.cmiLogin(data)
export const refreshToken = (token) => AuthAPI.refreshToken(token)
export const oauthLogin = (provider, code) => AuthAPI.oauthLogin?.(provider, code)
